import React from 'react';
import { Link } from "react-router-dom";
import { useLocalizedData } from '../hooks/useTranslatedContent';

export default function About({ homePageData }) {
    const { getLocalizedFirstItem } = useLocalizedData(homePageData);
    const about = getLocalizedFirstItem('aboutHome');

    if (!about || Object.keys(about).length === 0) {
        return null;
    }

    return (
        <section
            className="relative md:py-24 py-16"
            id="about"
        >
            <div className="absolute inset-0 bg-black/10 pointer-events-none z-0"></div>
            <div className="container mx-auto relative z-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 md:grid-cols-2 gap-10 items-center">
                    <div className="lg:col-span-5">
                        <div className="relative">
                            <img
                                src={about.img || '/default-about.jpg'}
                                className="rounded-lg shadow-lg relative"
                                alt={about.title || "About Us"}
                            />
                        </div>
                    </div>
                    <div className="lg:col-span-7">
                        <div className="lg:ms-7">
                            <h3 className="mb-4 md:text-2xl text-xl font-medium text-slate-600">
                                {about.title || "About Us"}
                            </h3>

                            <div
                                className="text-slate-400 dark:text-slate-300 max-w-2xl mx-auto"
                                dangerouslySetInnerHTML={{
                                    __html: about.description ||
                                        "Start working with us that can provide everything you need to generate awareness, drive traffic, connect."
                                }}
                            />

                            <div className="relative mt-8">
                                <Link
                                    to={about.btnLink || "/about"}
                                    className="py-2 px-5 inline-block font-normal tracking-wide border align-middle transition duration-500 ease-in-out text-base text-center bg-black hover:bg-black/80 border-black text-white rounded-md"
                                >
                                    {about.btnName || "Read More"} <i className="uil uil-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}